import { Navigate, createFileRoute } from "@tanstack/react-router"

import { useAbility, useAbilityReady } from "@/lib/ability"

// The admin area starts at the tenant list; the content role, which sees no
// tenants, at its content pages.
function AdminStart() {
  const ability = useAbility()
  const ready = useAbilityReady()
  if (!ready) return null
  return (
    <Navigate
      to={ability.can("read", "Administration") ? "/admin/mandanten" : "/admin/inhalte"}
      replace
    />
  )
}

export const Route = createFileRoute("/_app/admin/")({
  component: AdminStart,
})
